



































import Vue, { VueConstructor } from "vue";
import { Client } from "@/client";
import { Action } from "@/store/game";
import { gameStore } from "@/store/game/store";
export default (Vue as VueConstructor<
  Vue & {
    $refs: {
      gameLink: HTMLInputElement;
    };
  }
>).extend({
  data() {
    return {
      showTooltip1: false
    };
  },
  computed: {
    joined(): boolean {
      //return !!gameStore.state.gid;
      return true;
    },
    gameLink(): string {
      return window.location.href.split("?")[0] + "?gid=" + gameStore.state.gid;
    },
    isOwner() {
      return gameStore.state.isOwner;
    }
  },
  methods: {
    copyLink(input: HTMLInputElement) {
      input.select();
      input.setSelectionRange(0, 99999);
      /*For mobile devices*/
      document.execCommand("copy");
      this.showTooltip1 = true;
      this.$nextTick(() => {
        this.showTooltip1 = false;
      });
    },
    newGame() {
      window.location.href = window.location.href.split("?")[0];
    },
    start() {
      Client.getInstance().send({
        action: Action.start
      });
    }
  }
});
